import {
  ChatBubbleLeftRightIcon,
  ExclamationCircleIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline';
import React, { FunctionComponent, ReactNode } from 'react';

interface NonIdealStateProps {
  icon?: 'search' | 'social-media' | 'error' | ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

const iconFor = (icon: NonIdealStateProps['icon']) => {
  const className = 'h-14 w-14 text-gray-400';
  switch (icon) {
    case 'search':
      return <MagnifyingGlassIcon className={className} aria-hidden="true" />;
    case 'social-media':
      return <ChatBubbleLeftRightIcon className={className} aria-hidden="true" />;
    case 'error':
      return <ExclamationCircleIcon className={className} aria-hidden="true" />;
    default:
      return icon || null;
  }
};

/** Empty-state block (replaces the Blueprint NonIdealState). */
const NonIdealState: FunctionComponent<NonIdealStateProps> = ({
  icon,
  title,
  description,
  action,
}) => (
  <div className="flex flex-col items-center justify-center text-center max-w-sm mx-auto py-8">
    {iconFor(icon)}
    {title && <h4 className="mt-4 text-lg font-bold text-gray-700">{title}</h4>}
    {description && <p className="mt-2 text-sm text-gray-500">{description}</p>}
    {action}
  </div>
);

export default NonIdealState;
